"use client";

import { routes } from "@/lib/utils/routes";
import { useRouter, useSearchParams } from "next/navigation";
import Pagination from "rc-pagination";

export const CompanyPaging = ({
  limit,
  total,
}: {
  limit: number;
  total: number;
}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());
  const onChangePage = (page: number) => {
    params.set("page", page.toString());
    router.push(`${routes.company.list}?${params.toString()}`);
  };

  return (
    <Pagination
      pageSize={limit}
      className="ant-pagination"
      onChange={onChangePage}
      current={1}
      total={total}
    />
  );
};
